module.exports = __webpack_public_path__ + "static/turtle-creek-house02-f1761abd3d7a822b3f2f0c246f59566f.jpg";